<template>
  <div class="buttons">
    <span class="btn btn-bordered-red">Request Pricing</span>
    <span class="btn btn-bordered-blue">Request One-to-One Demo</span>
  </div>
</template>

<script>
  export default {
    name: 'HeaderButtons',
  };
</script>

<style lang="less" scoped>
  .buttons {
    position: absolute;
    top: -89px;
    right: -15px;
    padding: 24px 0;
    z-index: 4;
    background: #fff;

    .btn-bordered-red, .btn-bordered-blue {
      border-radius: 5px;
      border: 2px solid #da262e;
      color: #da262e;
      font-size: 1.4rem;
      font-weight: 600;

      &:hover, &:focus, &:active {
        background: #da262e;
        color: #fff;
      }
    }

    .btn-bordered-blue {
      border: 2px solid #008cce;
      color: #008cce;
      &:hover, &:focus, &:active {
        background: #008cce;
      }
    }

    span {
      padding: 8px 20px;
      min-width: 225px;
      margin: 0 15px;
    }
  }
</style>